// @ts-nocheck
import common from "@store/Themes/common/styleguide/components/link";
import Styleguide from "@toolkit/Framework/Types/Styleguide";
import { css } from "styled-components";

const link: Styleguide["link"] = {
    defaultProps: {
        ...common?.defaultProps,
        css: css`
            ${common?.defaultProps?.css}
            font-weight: ${({ theme }) => theme.design.typography.weight.bold};
        `,
    },
};

export default link;
